import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import Api, { exceptionNotificationAPI } from '../../services/api';
import Form from 'react-bootstrap/Form';
import { handleAddZeroes } from '../../services/functions';
import ModalRejectPartial from '../ModalRejectPartial';
//Components
import { error_message, info_message, success_message } from '../Toast/index';
import { saveAs } from 'file-saver';
import { read, utils } from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';

//Style
import { Container } from './styles';
import { FormCheck } from 'react-bootstrap';

const ModuleButtons = ({ userRoles, showButtons, isEditable, moduleID, answers,
    selectedCompanyID, selectedReportYearID, loadData, save, moduleObject, setModuleObject, showCloseButton,
    setLoading, setLoadingSection = null, versionIdentifier = null, status = null, setShowFixedHeader = null, setReadConsent = null, readConsent = null, versionID = null, needReadConsent = null, subSectionKPIs, selectedTobaccoTypes, selectedCountries, selectedFuelTypes, fixedKpisList }) => {

    const [showAgreeConsent, setShowAgreeConsent] = useState(false);
    const [showModalRejectPartial, setShowModalRejectPartial] = useState(false);
    const [subSectionKPIsToReject, setSubSectionKPIsToReject] = useState([]);
    const [userObject, setUserObject] = useState(JSON.parse(localStorage.getItem('@QualityApp:user')));
    const [showSendButton, setShowSendButton] = useState(false);
    const hiddenDivRef = useRef(null);
    const [debugLog, setDebugLog] = useState([]);
    const [isConverting, setIsConverting] = useState(false);

    const [ssksToReject, setSsksToReject] = useState([]);
    const COLUMN_ROW_TYPES = {
        'Simple': 1,
        'Country': 2,
        'FuelType': 3,
        'TobaccoType': 4,
        'Year': 5,
    }

    useEffect(() => {
        if (versionIdentifier != null) {
            if (status != 3 || status != 5) {
                setShowSendButton(true)
            }
        }
        else if (versionIdentifier == null && status != 7) {
            setShowSendButton(true)
        }
    }, [versionIdentifier, status])

    const handleSend = async (event) => {
        event.preventDefault();

        var isFinalVersion = moduleObject?.version?.isFinalVersion;
        var isPartialRejected = moduleObject?.version?.rejectedFormValuesList != null && moduleObject?.version?.rejectedFormValuesList.length > 0;

        if (isPartialRejected) {
            Swal.fire({
                title: 'Notice!',
                text: "This module has already been previously submitted and the global approver rejected only a few KPIs. This means you must submit the new responses keeping the same version as previous submission. Click in the button below to proceed with the approval process.",
                icon: 'warning',
                confirmButtonColor: '#B0B0BB',
                confirmButtonText: 'Send',
                showCloseButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await save(answers, moduleID, true, true, false);
                }
            })

        } else {
            save(answers, moduleID, true, true, false);

        }
    }

    const handleSaveActionPlans = async (event) => {
        event.preventDefault();
        save(answers, moduleID, true, true, true);
    }

    const handleApprove = async (event) => {
        event.preventDefault();

        setLoading(true);
        if (setLoadingSection != null) {
            setLoadingSection(true);
        }

        await Api.post(`FormValue/approve?moduleID=${moduleID}&selectedCompanyID=${selectedCompanyID}&reportYearID=${selectedReportYearID}${versionIdentifier != null ? `&versionIdentifier=${versionIdentifier}` : ""}`).then((result) => {
            success_message("The data was approved successfully!");
            loadData();
            if (setShowFixedHeader != null)
                setShowFixedHeader(false);
        }).catch((error) => {
            exceptionNotificationAPI(error);
            setLoading(false);
            if (setLoadingSection != null) {
                setLoadingSection(false);
            }
            if (setShowFixedHeader != null)
                setShowFixedHeader(false);
        });
    }

    function validateSelectAnswers(colType, indexVal) {
        if (colType.toString() == COLUMN_ROW_TYPES['Country'].toString()) {
            return selectedCountries.find(c => c.value.toString() == indexVal.toString())?.text;
        } else if (colType.toString() == COLUMN_ROW_TYPES['FuelType'].toString()) {
            return selectedFuelTypes.find(c => c.value.toString() == indexVal.toString())?.text;
        } else if (colType.toString() == COLUMN_ROW_TYPES['TobaccoType'].toString()) {
            return selectedTobaccoTypes.find(c => c.value.toString() == indexVal.toString())?.text;
        }
    }

    function validateSelectedIndex(colType, index) {
        if (colType.toString() == COLUMN_ROW_TYPES['Country'].toString()) {
            return selectedCountries[index]?.text;
        } else if (colType.toString() == COLUMN_ROW_TYPES['FuelType'].toString()) {
            return selectedFuelTypes[index]?.text;
        } else if (colType.toString() == COLUMN_ROW_TYPES['TobaccoType'].toString()) {
            return selectedTobaccoTypes[index]?.text;
        }
    }

    const handlePartialReject = async (event) => {
        event.preventDefault();

        //Kpis
        var kpis = [];
        moduleObject.data.sections.map((section) => {
            section.subSections.map((ss) => {
                ss.kpis.map((kpi) => {
                    kpis.push(kpi);
                });
            });
        });

        //Sections
        var sections = [];
        moduleObject.data.sections.map((section) => {
            sections.push(section);
        });

        //Answers
        var answers = moduleObject.answers;
        //Columns
        var cols = moduleObject.columnRows;
        //ParentColumns
        var parentCols = cols.filter(c => c.isParentColumn);

        //subSections
        var subSections = []
        moduleObject.data.sections.map((section) => {
            section.subSections.map((ss) => {
                subSections.push(ss);
            });
        });

        setShowModalRejectPartial(true);
        setSsksToReject([]);

        var sskRejectList = [];
        var bold = false; //Controla bold
        var isHighlight = false; // Controla Highlight
        var lastRowSSkpi = null; //Controla primeiro objeto de rows
        var userObj = JSON.parse(localStorage.getItem('@QualityApp:user'));
        var isApproving = false;
        //Validate if user is global
        if ((moduleObject?.version?.status == 4 && userObj?.companyID == null && userRoles.includes("RoleApprover"))) {
            isApproving = true;
        }
        subSectionKPIs.forEach((ssk) => {
            bold = false;
            isHighlight = false;

            if (ssk.inputCalc != "Calculation") {
                let fromSubSection = subSections.find(ss => ss.subSectionID == ssk.subSectionID);
                let fromSection = sections.find(s => s.sectionID == fromSubSection?.sectionID);
                //If subsection has a number of Rows
                if (fromSubSection.numberOfRows != null && fromSubSection.numberOfRows > 0) {
                    //Add first entry with row values
                    if (lastRowSSkpi == null) {
                        lastRowSSkpi = ssk.refNumber;
                    }

                    var targetKpi = kpis.find(x => x.kpiid == ssk.kpiid);
                    var targetColumn = cols.find(c => c.columnRowID == ssk.columnRowID);
                    var targetParentColumn = targetColumn.parentColumnRowID != null ? parentCols.find(pc => pc.columnRowOrder == targetColumn.parentColumnRowID && pc.subSectionID == targetColumn.subSectionID) : null
                    var targetAnswer = answers.find(a => a.subSectionKPIID == ssk.subSectionKPIID && a.row == 0);
                    var answer = targetAnswer?.numberValue != null ? targetAnswer?.numberValue : targetAnswer?.textValue;

                    var columnDescription = targetColumn.name;

                    if (targetColumn.type != 1 && targetColumn.type != 5 && targetAnswer != null) {
                        //Validate if answer needs to be altered by selector description - isSelectAnswer
                        if (targetColumn.kpiReference == targetAnswer.refNumber) {
                            answer = validateSelectAnswers(targetColumn.type, answer);
                        }
                    }

                    if (targetParentColumn != null) {
                        columnDescription = `${targetParentColumn.name} - ${targetColumn.name}`
                    }

                    if (lastRowSSkpi == ssk.refNumber) {
                        bold = true;
                    }



                    //Validate if user is global
                    if ((moduleObject?.version?.status == 4 && userObj?.companyID == null && userRoles.includes("RoleApprover"))) {
                        isApproving = true;
                    }

                    if (fixedKpisList?.some(x => x.subSectionKPIID == ssk.subSectionKPIID && x.rowIndex == 0) && !moduleObject.isEditable && isApproving) {
                        isHighlight = true;
                    }


                    if (blockLocalApproverRejection()) {
                        for (let ind = 0; ind < moduleObject.version?.globalRejectFormValuesList?.length; ind++) {
                            let element = moduleObject.version?.globalRejectFormValuesList[ind];
                            if (element.subSectionKPIID == ssk.subSectionKPIID && element.rowIndex == 0 && element.columnIndex == null) {
                                sskRejectList.push(
                                    {
                                        rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                        subSectionKpiID: ssk.subSectionKPIID,
                                        refNumber: ssk.refNumber,
                                        rowIndex: 0,
                                        columnIndex: null,
                                        kpiDescription: targetKpi?.description,
                                        columnDesc: columnDescription,
                                        answer: answer,
                                        unitMeasure: ssk.unitMeasure,
                                        isBold: bold,
                                        subSectionID: ssk.subSectionID,
                                        sectionID: fromSection?.sectionID,
                                        isHighlight: isHighlight
                                    }
                                );
                            }
                        }
                    } else {
                        sskRejectList.push(
                            {
                                rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                subSectionKpiID: ssk.subSectionKPIID,
                                refNumber: ssk.refNumber,
                                rowIndex: 0,
                                columnIndex: null,
                                kpiDescription: targetKpi?.description,
                                columnDesc: columnDescription,
                                answer: answer,
                                unitMeasure: ssk.unitMeasure,
                                isBold: bold,
                                subSectionID: ssk.subSectionID,
                                sectionID: fromSection?.sectionID,
                                isHighlight: isHighlight
                            }
                        );
                    }



                    //add extra SSK for each of the other rows
                    for (let i = 1; i < fromSubSection.numberOfRows; i++) {
                        isHighlight = false;
                        targetAnswer = answers.find(a => a.subSectionKPIID == ssk.subSectionKPIID && a.row == i);
                        answer = targetAnswer?.numberValue != null ? targetAnswer?.numberValue : targetAnswer?.textValue;
                        if (targetColumn.type != 1 && targetColumn.type != 5 && answer != null) {
                            //Validate if answer needs to be altered by selector description - isSelectAnswer
                            if (targetColumn.kpiReference == targetAnswer.refNumber) {
                                answer = validateSelectAnswers(targetColumn.type, answer);
                            }
                        }

                        if (lastRowSSkpi == ssk.refNumber) {
                            bold = true;
                        }

                        if (fixedKpisList?.some(x => x.subSectionKPIID == ssk.subSectionKPIID && x.rowIndex == i) && !moduleObject.isEditable && isApproving) {
                            isHighlight = true;
                        }

                        if (blockLocalApproverRejection()) {
                            for (let ind = 0; ind < moduleObject.version?.globalRejectFormValuesList?.length; ind++) {
                                let element = moduleObject.version?.globalRejectFormValuesList[ind];
                                if (element.subSectionKPIID == ssk.subSectionKPIID && element.rowIndex == i && element.columnIndex == null) {
                                    sskRejectList.push(
                                        {
                                            rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                            subSectionKpiID: ssk.subSectionKPIID,
                                            refNumber: ssk.refNumber,
                                            rowIndex: i,
                                            columnIndex: null,
                                            kpiDescription: targetKpi?.description,
                                            columnDesc: columnDescription,
                                            answer: answer,
                                            unitMeasure: ssk.unitMeasure,
                                            isBold: bold,
                                            subSectionID: ssk.subSectionID,
                                            sectionID: fromSection?.sectionID,
                                            isHighlight: isHighlight
                                        });
                                }
                            };
                        } else {
                            sskRejectList.push(
                                {
                                    rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                    subSectionKpiID: ssk.subSectionKPIID,
                                    refNumber: ssk.refNumber,
                                    rowIndex: i,
                                    columnIndex: null,
                                    kpiDescription: targetKpi?.description,
                                    columnDesc: columnDescription,
                                    answer: answer,
                                    unitMeasure: ssk.unitMeasure,
                                    isBold: bold,
                                    subSectionID: ssk.subSectionID,
                                    sectionID: fromSection?.sectionID,
                                    isHighlight: isHighlight
                                });
                        }
                    }

                }
                else {
                    lastRowSSkpi = null;
                    bold = false;
                    var targetKpi = kpis.find(x => x.kpiid == ssk.kpiid);
                    var targetColumn = cols.find(c => c.columnRowID == ssk.columnRowID);

                    //validate if targetColumn is tobacco type
                    if (targetColumn.type.toString() == COLUMN_ROW_TYPES['TobaccoType'].toString()) {

                        var targetParentColumn = targetColumn.parentColumnRowID != null ? parentCols.find(pc => pc.columnRowOrder == targetColumn.parentColumnRowID && pc.subSectionID == targetColumn.subSectionID) : null
                        var targetAnswer = answers.find(a => a.subSectionKPIID == ssk.subSectionKPIID && a.column == 0);
                        var answer = targetAnswer?.numberValue != null ? targetAnswer?.numberValue : targetAnswer?.textValue;

                        var columnDescription = answer;



                        if (targetColumn.type != 1 && targetColumn.type != 5) {
                            //Adjust column description to match value selected
                            columnDescription = validateSelectedIndex(targetColumn.type, 0);

                            if (answer != null) {
                                //Validate if answer needs to be altered by selector description - isSelectAnswer
                                if (targetColumn?.kpiReference == targetAnswer?.refNumber) {
                                    answer = validateSelectAnswers(targetColumn.type, answer);
                                }
                            }
                        }


                        if (targetParentColumn != null) {
                            columnDescription = `${targetParentColumn.name} - ${columnDescription}`
                        }

                        if (fixedKpisList?.some(x => x.subSectionKPIID == ssk.subSectionKPIID && x.columnIndex == 0) && !moduleObject.isEditable && isApproving) {
                            isHighlight = true;
                        }

                        if (columnDescription != "" && columnDescription != null) {
                            if (blockLocalApproverRejection()) {
                                for (let ind = 0; ind < moduleObject.version?.globalRejectFormValuesList?.length; ind++) {
                                    let element = moduleObject.version?.globalRejectFormValuesList[ind];
                                    if (element.subSectionKPIID == ssk.subSectionKPIID && element.rowIndex == null && element.columnIndex == 0) {
                                        sskRejectList.push(
                                            {
                                                rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                                subSectionKpiID: ssk.subSectionKPIID,
                                                refNumber: ssk.refNumber,
                                                rowIndex: null,
                                                columnIndex: 0,
                                                kpiDescription: targetKpi?.description,
                                                columnDesc: columnDescription,
                                                answer: answer,
                                                unitMeasure: ssk.unitMeasure,
                                                isBold: bold,
                                                subSectionID: ssk.subSectionID,
                                                sectionID: fromSection?.sectionID,
                                                isHighlight: isHighlight
                                            }
                                        );
                                    }
                                }
                            } else {
                                sskRejectList.push(
                                    {
                                        rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                        subSectionKpiID: ssk.subSectionKPIID,
                                        refNumber: ssk.refNumber,
                                        rowIndex: null,
                                        columnIndex: 0,
                                        kpiDescription: targetKpi?.description,
                                        columnDesc: columnDescription,
                                        answer: answer,
                                        unitMeasure: ssk.unitMeasure,
                                        isBold: bold,
                                        subSectionID: ssk.subSectionID,
                                        sectionID: fromSection?.sectionID,
                                        isHighlight: isHighlight
                                    }
                                );
                            }
                        }


                        //add extra SSK for each of the other columns
                        for (let i = 1; i < targetColumn.minimumQuantity; i++) {

                            targetAnswer = answers.find(a => a.subSectionKPIID == ssk.subSectionKPIID && a.column == i);
                            answer = targetAnswer?.numberValue != null ? targetAnswer?.numberValue : targetAnswer?.textValue;
                            columnDescription = targetColumn.name;
                            isHighlight = false;
                            //Validate if columnsType is from a selectedValue (TobaccoType for example)
                            if (targetColumn.type != 1 && targetColumn.type != 5) {
                                //Adjust column description to match value selected
                                columnDescription = validateSelectedIndex(targetColumn.type, i);
                                if (answer != null) {
                                    //Validate if answer needs to be altered by selector description - isSelectAnswer
                                    if (targetColumn?.kpiReference == targetAnswer?.refNumber) {
                                        answer = validateSelectAnswers(targetColumn.type, answer);
                                        columnDescription = answer;
                                    }
                                }
                            }

                            if (fixedKpisList?.some(x => x.subSectionKPIID == ssk.subSectionKPIID && x.columnIndex == i) && !moduleObject.isEditable && isApproving) {
                                isHighlight = true;
                            }

                            if (columnDescription != "" && columnDescription != null) {
                                if (blockLocalApproverRejection()) {
                                    for (let ind = 0; ind < moduleObject.version?.globalRejectFormValuesList?.length; ind++) {
                                        let element = moduleObject.version?.globalRejectFormValuesList[ind];
                                        if (element.subSectionKPIID == ssk.subSectionKPIID && element.rowIndex == null && element.columnIndex == i) {
                                            sskRejectList.push(
                                                {
                                                    rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                                    subSectionKpiID: ssk.subSectionKPIID,
                                                    refNumber: ssk.refNumber,
                                                    rowIndex: null,
                                                    columnIndex: i,
                                                    kpiDescription: targetKpi?.description,
                                                    columnDesc: columnDescription,
                                                    answer: answer,
                                                    unitMeasure: ssk.unitMeasure,
                                                    isBold: bold,
                                                    subSectionID: ssk.subSectionID,
                                                    sectionID: fromSection?.sectionID,
                                                    isHighlight: isHighlight
                                                }
                                            );
                                        }
                                    }
                                } else {
                                    sskRejectList.push(
                                        {
                                            rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                            subSectionKpiID: ssk.subSectionKPIID,
                                            refNumber: ssk.refNumber,
                                            rowIndex: null,
                                            columnIndex: i,
                                            kpiDescription: targetKpi?.description,
                                            columnDesc: columnDescription,
                                            answer: answer,
                                            unitMeasure: ssk.unitMeasure,
                                            isBold: bold,
                                            subSectionID: ssk.subSectionID,
                                            sectionID: fromSection?.sectionID,
                                            isHighlight: isHighlight
                                        }
                                    );
                                }
                            }
                        }
                    } else {

                        var targetParentColumn = targetColumn.parentColumnRowID != null ? parentCols.find(pc => pc.columnRowOrder == targetColumn.parentColumnRowID && pc.subSectionID == targetColumn.subSectionID) : null
                        var targetAnswer = answers.find(a => a.subSectionKPIID == ssk.subSectionKPIID);
                        var answer = targetAnswer?.numberValue != null ? targetAnswer?.numberValue : targetAnswer?.textValue;
                        var columnDescription = targetColumn.name;

                        if (targetParentColumn != null) {
                            columnDescription = `${targetParentColumn.name} - ${targetColumn.name}`
                        }

                        if (fixedKpisList?.some(x => x.subSectionKPIID == ssk.subSectionKPIID) && !moduleObject.isEditable && isApproving) {
                            isHighlight = true;
                        }

                        if (blockLocalApproverRejection()) {
                            for (let ind = 0; ind < moduleObject.version?.globalRejectFormValuesList?.length; ind++) {
                                let element = moduleObject.version?.globalRejectFormValuesList[ind];
                                if (element.subSectionKPIID == ssk.subSectionKPIID && element.rowIndex == null && element.columnIndex == null) {
                                    sskRejectList.push(
                                        {
                                            rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                            subSectionKpiID: ssk.subSectionKPIID,
                                            refNumber: ssk.refNumber,
                                            rowIndex: null,
                                            columnIndex: null,
                                            kpiDescription: targetKpi?.description,
                                            columnDesc: columnDescription,
                                            answer: answer,
                                            unitMeasure: ssk.unitMeasure,
                                            isBold: bold,
                                            subSectionID: ssk.subSectionID,
                                            sectionID: fromSection?.sectionID,
                                            isHighlight: isHighlight
                                        }
                                    );
                                }

                            }
                        } else {
                            sskRejectList.push(
                                {
                                    rejectedInFormValueVersionID: moduleObject.version.formValueVersionID,
                                    subSectionKpiID: ssk.subSectionKPIID,
                                    refNumber: ssk.refNumber,
                                    rowIndex: null,
                                    columnIndex: null,
                                    kpiDescription: targetKpi?.description,
                                    columnDesc: columnDescription,
                                    answer: answer,
                                    unitMeasure: ssk.unitMeasure,
                                    isBold: bold,
                                    subSectionID: ssk.subSectionID,
                                    sectionID: fromSection?.sectionID,
                                    isHighlight: isHighlight
                                }
                            );
                        }
                    }


                }

                //Ordena subSectionKPIList
                sskRejectList.sort((a, b) => {
                    if (a.sectionID === b.sectionID) {
                        if (a.subSectionID === b.subSectionID) {
                            if (a.rowIndex === b.rowIndex) {
                                return a.subSectionKPIID < b.subSectionKPIID ? -1 : 1;
                            }
                            return a.rowIndex - b.rowIndex;
                        }
                        return a.subSectionID - b.subSectionID;
                    }
                    return a.sectionID - b.sectionID;
                });

            }
        });

        setSsksToReject(sskRejectList);

    }


    const handleReject = async (event) => {
        event.preventDefault();

        Swal.fire({
            title: 'Please specify the reason to reject all',
            input: 'textarea',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Comment',
            confirmButtonColor: '#112A61',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                if (setLoadingSection != null) {
                    setLoadingSection(true);
                }
                const objToRequest = {
                    "moduleID": moduleID,
                    "selectedCompanyID": selectedCompanyID,
                    "commentApprover": result.value,
                    "reportYearID": selectedReportYearID,
                    "versionIdentifier": versionIdentifier != null ? versionIdentifier : null
                }

                await Api.post(`FormValue/reject`, objToRequest).then((result) => {
                    success_message("The data was rejected successfully!");
                    loadData();
                    if (setShowFixedHeader != null)
                        setShowFixedHeader(false);
                }).catch((error) => {
                    exceptionNotificationAPI(error);
                    setLoading(false);
                    if (setLoadingSection != null) {
                        setLoadingSection(false);
                    }
                    if (setShowFixedHeader != null)
                        setShowFixedHeader(false);
                });
            }
        })

    }

    const handleReactive = async (event) => {
        event.preventDefault();

        Swal.fire({
            title: 'Please specify the reason and KPI rejected',
            input: 'textarea',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Comment',
            confirmButtonColor: '#112A61',
            showLoaderOnConfirm: true,
            allowOutsideClick: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                //setLoading(true);

                const objToRequest = {
                    "moduleID": moduleID,
                    "selectedCompanyID": selectedCompanyID,
                    "commentApprover": result.value,
                    "reportYearID": selectedReportYearID,
                    "versionIdentifier": versionIdentifier != null ? versionIdentifier : null
                }

                await Api.post(`FormValue/reactive`, objToRequest).then((result) => {
                    success_message("The module was reactive successfully!");
                    loadData();
                    if (setShowFixedHeader != null)
                        setShowFixedHeader(false);
                }).catch((error) => {
                    exceptionNotificationAPI(error);
                    setLoading(false);
                    if (setLoadingSection != null) {
                        setLoadingSection(false);
                    }
                    if (setShowFixedHeader != null)
                        setShowFixedHeader(false);
                });
            }
        })
    }

    const blockLocalApproverRejection = () => {
        return (userObject?.companyID != null && moduleObject?.version?.globalRejectFormValuesList != null && moduleObject?.version?.globalRejectFormValuesList?.length > 0);
    }

    const hasAddZeroesButton = () => {
        return [14, 15, 16, 17, 18].includes(moduleID);
    }

    const handleChecked = (value) => {
        if (value) {
            Swal.fire({
                title: 'Are you sure you have finished reading all the data in this module?',
                showCancelButton: true,
                cancelButtonColor: '#B0B0BB',
                confirmButtonText: 'Confirm',
                confirmButtonColor: '#112A61',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading()
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true);
                    if (setLoadingSection != null) {
                        setLoadingSection(true);
                    }

                    const objToRequest = {
                        "moduleID": moduleID,
                        "companyID": selectedCompanyID,
                        "formValueVersionID": versionID,
                        "reportYearID": selectedReportYearID,
                        "versionIdentifier": versionIdentifier != null ? versionIdentifier : null
                    }

                    await Api.post(`ReadConsent/new`, objToRequest).then((result) => {
                        success_message("Your consent was successfully saved!");
                        loadData();
                        setShowAgreeConsent(true);
                        if (setShowFixedHeader != null)
                            setShowFixedHeader(false);
                    }).catch((error) => {
                        exceptionNotificationAPI(error);
                        setLoading(false);
                        if (setLoadingSection != null) {
                            setLoadingSection(false);
                        }
                        if (setShowFixedHeader != null)
                            setShowFixedHeader(false);
                    });
                }
                else {
                    document.querySelector('#chkAgree').checked = false;
                    setShowAgreeConsent(false);
                }
            })
        }
        else {
            document.querySelector('#chkAgree').checked = false;
            setShowAgreeConsent(false);
        }

    }

    const sendExport = () => {
        if (selectedReportYearID == null || selectedReportYearID.length == 0) {
            info_message("Select an crop year");
            return;
        }

        setLoading(true);

        var obj =
        {
            'CompanyID': selectedCompanyID,
            'ReportYearID': selectedReportYearID,
            'versionIdentifier': versionIdentifier
        }


        Api.post(`export/getCurrentWaiver`, obj, { responseType: 'blob' })
            .then((response) => {
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // Internet Explorer
                    window.navigator.msSaveBlob(response.data, "Export_Waiver.xlsx");
                } else {
                    // Outros navegadores
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Export_Waiver.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }

                // Atualizar estados de carregamento
                setLoading(false);
            })
            .catch((error) => {
                // Lidar com erros
                exceptionNotificationAPI(error);
            });
    }
    const sendExportFumigation = async () => {
        if (!selectedReportYearID || selectedReportYearID.length === 0) {
            info_message("Select a crop year");
            return;
        }

        try {
            setIsConverting(true);

            // Fazer requisição com headers apropriados
            const response = await Api.post(
                `export/getFumigation?moduleID=${moduleID}&reportYearID=${selectedReportYearID}
                &companyID=${selectedCompanyID}&versionIdentifier=${versionIdentifier}`
            );

            // Converter para PDF
            await convertExcelToPdf(response.data);

            success_message("PDF gerado com sucesso!");

        } catch (error) {
            console.error('Erro na exportação:', error);
            error_message(`Erro ao gerar PDF: ${error.message}`);
            exceptionNotificationAPI(error);
        } finally {
            setIsConverting(false);
        }
    }

    const addDebugLog = (message) => {
        console.log(message);
        setDebugLog(prev => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
    };

    // Função principal de conversão
    const convertExcelToPdf = async (htmlContent) => {
        try {
            // 5. Converter HTML para PDF
            addDebugLog('Convertendo HTML para PDF...');
            const pdfBlob = await htmlToPdf(htmlContent);

            // 6. Fazer download
            addDebugLog('Iniciando download...');
            downloadPdf(pdfBlob, 'Fumigation_Certificate.pdf');

            addDebugLog('✅ Conversão concluída com sucesso!');
            return pdfBlob;

        } catch (error) {
            addDebugLog(`❌ Erro na conversão: ${error.message}`);
            throw error;
        }
    };

    // Função para converter HTML em PDF
    // const htmlToPdf = async (htmlContent) => {
    //     // Parâmetros de A4 retrato
    //     const a4WidthMm = 210;
    //     const a4HeightMm = 297;
    //     const marginRightMm = 10;
    //     const a4WidthPx = 794;    // ~96dpi
    //     const a4HeightPx = 1123;

    //     // Largura do conteúdo (tabela) máxima permitida (em px)
    //     const maxContentWidthPx = a4WidthPx - (marginRightMm / a4WidthMm) * a4WidthPx;
    //     const imgWidth = a4WidthMm - marginRightMm; // largura da imagem no PDF, em mm

    //     // 1. Cria container temporário invisível
    //     const tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = htmlContent;
    //     tempDiv.style.position = 'absolute';
    //     tempDiv.style.left = '-9999px';
    //     tempDiv.style.top = '0px';
    //     tempDiv.style.background = 'white';
    //     tempDiv.style.overflow = 'visible';
    //     tempDiv.style.width = 'auto'; // permite medir a tabela real

    //     document.body.appendChild(tempDiv);

    //     // 2. Aguarda renderização do DOM (para fontes, imagens etc)
    //     await new Promise(resolve => setTimeout(resolve, 200));

    //     // 3. Mede a largura real da tabela (ou conteúdo principal)
    //     const table = tempDiv.querySelector('table');
    //     const tableWidthPx = table ? table.offsetWidth : a4WidthPx;

    //     // 4. Calcula a escala para caber na largura máxima do PDF
    //     const scale = tableWidthPx > maxContentWidthPx ? maxContentWidthPx / tableWidthPx : 1;

    //     // 5. Aplica escala CSS no HTML antes de renderizar
    //     tempDiv.style.transformOrigin = 'top left';
    //     tempDiv.style.transform = `scale(${scale})`;
    //     tempDiv.style.width = `${tableWidthPx}px`;

    //     // 6. Aguarda layout atualizado
    //     await new Promise(resolve => setTimeout(resolve, 80));

    //     // 7. Gera o canvas (do HTML já escalado)
    //     const canvas = await html2canvas(tempDiv, {
    //         scale: 2,
    //         useCORS: true,
    //         allowTaint: true,
    //         backgroundColor: '#fff',
    //         logging: false,
    //         width: tableWidthPx * scale
    //     });

    //     // 8. Calcula altura total da imagem para PDF (em mm, proporcional)
    //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //     // 9. Cria o PDF (portrait)
    //     const pdf = new jsPDF({
    //         orientation: 'portrait',
    //         unit: 'mm',
    //         format: 'a4'
    //     });

    //     // 10. Quebra de página: fatia a imagem do canvas em múltiplas páginas
    //     const pageHeightMm = a4HeightMm;
    //     let position = 0;
    //     let page = 0;
    //     let renderedHeightMm = 0;

    //     while (renderedHeightMm < imgHeight) {
    //         if (page > 0) pdf.addPage();
    //         // Calcula qual parte do canvas vamos usar nesta página
    //         const pageHeightPx = canvas.height * (pageHeightMm / imgHeight);

    //         // Cria um canvas temporário do tamanho de uma página
    //         const pageCanvas = document.createElement('canvas');
    //         pageCanvas.width = canvas.width;
    //         pageCanvas.height = pageHeightPx;
    //         const pageCtx = pageCanvas.getContext('2d');
    //         // Copia a fatia do canvas principal para a página atual
    //         pageCtx.drawImage(
    //             canvas,
    //             0, position,
    //             canvas.width, pageHeightPx,
    //             0, 0,
    //             canvas.width, pageHeightPx
    //         );

    //         // Adiciona a imagem desta página ao PDF
    //         const pageImgHeightMm = pageHeightMm > (imgHeight - renderedHeightMm) ? (imgHeight - renderedHeightMm) : pageHeightMm;
    //         pdf.addImage(
    //             pageCanvas,
    //             'PNG',
    //             0, 0,
    //             imgWidth, pageImgHeightMm
    //         );

    //         renderedHeightMm += pageHeightMm;
    //         position += pageHeightPx;
    //         page++;
    //     }

    //     // 11. Remove o HTML temporário
    //     document.body.removeChild(tempDiv);

    //     // 12. Retorna o Blob do PDF (para download ou preview)
    //     return pdf.output('blob');
    // };

    // Função para fazer download do PDF

//     const htmlToPdf = async (htmlContent) => {
//         // -----------------------------
//   // 1. Parâmetros de página A4
//   // -----------------------------
//   const a4WidthMm = 210;         // largura A4 em mm (formato retrato)
//   const a4HeightMm = 297;        // altura A4 em mm
//   const marginMm = 10;           // margem de 10 mm em todos os lados
//   const pxPerMm = 3.78;          // conversão aproximada: 1 mm ≈ 3.78 px (96dpi)

//   // Área útil para conteúdo (em mm)
//   const contentWidthMm = a4WidthMm - 2 * marginMm;   // ex.: 210 - 20 = 190 mm
//   const contentHeightMm = a4HeightMm - 2 * marginMm; // ex.: 297 - 20 = 277 mm

//   // Convertendo largura máxima de conteúdo para pixels:
//   const maxContentWidthPx = contentWidthMm * pxPerMm; // ex.: 190 mm × 3.78 ≈ 718 px

//   // -----------------------------
//   // 2. Criar container temporário
//   // -----------------------------
//   const tempDiv = document.createElement('div');
//   tempDiv.innerHTML = htmlContent;
//   tempDiv.style.position = 'absolute';
//   tempDiv.style.left = '-9999px';
//   tempDiv.style.top = '0';
//   tempDiv.style.background = 'white';
//   tempDiv.style.overflow = 'visible';
//   tempDiv.style.width = 'auto'; // deixa a tabela ocupar seu tamanho real

//   document.body.appendChild(tempDiv);

//   // Espera breve para carregar CSS, fontes e imagens
//   await new Promise((resolve) => setTimeout(resolve, 200));

//   // -----------------------------
//   // 3. Medir largura da tabela
//   // -----------------------------
//   const tableEl = tempDiv.querySelector('table');
//   const tableWidthPx = tableEl
//     ? tableEl.offsetWidth
//     : contentWidthMm * pxPerMm;

//   // -----------------------------
//   // 4. Calcular fator de escala
//   // -----------------------------
//   const scaleFactor =
//     tableWidthPx > maxContentWidthPx ? maxContentWidthPx / tableWidthPx : 1;

//   // -----------------------------
//   // 5. Aplicar escala CSS no container
//   // -----------------------------
//   tempDiv.style.transformOrigin = 'top left';
//   tempDiv.style.transform = `scale(${scaleFactor})`;
//   tempDiv.style.width = `${tableWidthPx}px`; // mantem largura CSS original

//   // Espera breve para que o layout se ajuste após o transform
//   await new Promise((resolve) => setTimeout(resolve, 80));

//   // -----------------------------
//   // 6. Identificar inícios de bloco via duas linhas em branco
//   // -----------------------------
//   // Percorre todas as <tr> para encontrar pares consecutivos de linhas totalmente vazias.
//   const trs = Array.from(tempDiv.querySelectorAll('tr'));
//   const blockStartOffsetsPx = [];

//   for (let i = 0; i < trs.length - 2; i++) {
//     const isBlankRow = (tr) => {
//       // Verifica se todas as células <td> estão vazias ou espaços em branco
//       const tds = Array.from(tr.querySelectorAll('td'));
//       if (tds.length === 0) return false;
//       return tds.every((td) => td.textContent.trim() === '');
//     };

//     if (isBlankRow(trs[i]) && isBlankRow(trs[i + 1])) {
//       // O próximo <tr> (i+2) marca o início do novo bloco
//       const nextIdx = i + 2;
//       if (nextIdx < trs.length) {
//         const blockEl = trs[nextIdx];
//         // offsetTop antes da escala (px)
//         const offset = blockEl.offsetTop;
//         blockStartOffsetsPx.push(offset);
//       }
//     }
//   }

//   // -----------------------------
//   // 7. Capturar canvas com html2canvas (scale = 2)
//   // -----------------------------
//   const canvas = await html2canvas(tempDiv, {
//     scale: 2,
//     useCORS: true,
//     allowTaint: true,
//     backgroundColor: '#fff',
//     logging: false,
//     width: tableWidthPx * scaleFactor,
//   });

//   // -----------------------------
//   // 8. Converter dimensões do canvas para mm
//   // -----------------------------
//   const canvasWidthPx = canvas.width;   // = tableWidthPx × scaleFactor × 2
//   const canvasHeightPx = canvas.height;

//   const imgWidthMm = (canvasWidthPx / 2) / pxPerMm;   // largura real em mm
//   const imgHeightMm = (canvasHeightPx / 2) / pxPerMm; // altura real em mm

//   // -----------------------------
//   // 9. Converter offsets de bloco para espaço do canvas
//   // -----------------------------
//   // Cada offsetTop (px) antes da escala deve ser multiplicado por scaleFactor e por 2
//   const blockStartsCanvasPx = blockStartOffsetsPx.map(
//     (off) => off * scaleFactor * 2
//   );

//   // -----------------------------
//   // 10. Calcular altura de página em pixels do canvas
//   // -----------------------------
//   // contentHeightMm (mm) → * pxPerMm → *2 (html2canvas scale)
//   const pageHeightCanvasPx = contentHeightMm * pxPerMm * 2;

//   // -----------------------------
//   // 11. Montar fatias para cada página respeitando blocos
//   // -----------------------------
//   const slicesPx = [];
//   let cursorY = 0;

//   while (cursorY < canvasHeightPx) {
//     // Altura restante no canvas:
//     const remainingPx = canvasHeightPx - cursorY;

//     // Se couber tudo em uma página:
//     if (remainingPx <= pageHeightCanvasPx) {
//       slicesPx.push(remainingPx);
//       break;
//     }

//     // Chega-se ao final de uma página = cursorY + pageHeightCanvasPx
//     let sliceBottom = cursorY + pageHeightCanvasPx;

//     // Verifica se, no trecho (cursorY, sliceBottom), há início de bloco —
//     // Caso exista um blockStart entre (cursorY + 1) e sliceBottom - 1, devemos ajustar a fatia:
//     const eligibleBlocks = blockStartsCanvasPx
//       .filter((bs) => bs > cursorY && bs < sliceBottom)
//       .sort((a, b) => a - b);

//     if (eligibleBlocks.length > 0) {
//       // Pega o primeiro início de bloco dentro desta página:
//       const firstBlockStart = eligibleBlocks[0];
//       // Ajusta slice para terminar exatamente onde começa o bloco:
//       sliceBottom = firstBlockStart;
//     }

//     const sliceHeight = sliceBottom - cursorY;
//     slicesPx.push(sliceHeight);
//     cursorY += sliceHeight;
//   }

//   // -----------------------------
//   // 12. Renderizar cada fatia no PDF
//   // -----------------------------
//   const pdf = new jsPDF({
//     orientation: 'portrait',
//     unit: 'mm',
//     format: 'a4',
//   });

//   let positionY = 0;
//   let pageIndex = 0;

//   for (const sliceHeightPx of slicesPx) {
//     if (pageIndex > 0) {
//       pdf.addPage();
//     }

//     // Cria canvas temporário da altura exata da fatia
//     const pageCanvas = document.createElement('canvas');
//     pageCanvas.width = canvasWidthPx;
//     pageCanvas.height = sliceHeightPx;
//     const pageCtx = pageCanvas.getContext('2d');

//     // Copia apenas a fatia vertical do canvas original para este canvas
//     pageCtx.drawImage(
//       canvas,
//       0,
//       positionY,
//       canvasWidthPx,
//       sliceHeightPx,
//       0,
//       0,
//       canvasWidthPx,
//       sliceHeightPx
//     );

//     // Converte sliceHeightPx → mm: (sliceHeightPx / 2) / pxPerMm
//     const sliceHeightMm = (sliceHeightPx / 2) / pxPerMm;

//     // Adiciona a imagem desta fatia ao PDF, respeitando margens
//     pdf.addImage(
//       pageCanvas,
//       'PNG',
//       marginMm,      // x em mm (margem esquerda)
//       marginMm,      // y em mm (margem superior)
//       imgWidthMm,    // largura em mm
//       sliceHeightMm  // altura em mm
//     );

//     positionY += sliceHeightPx;
//     pageIndex++;
//   }

//   // -----------------------------
//   // 13. Remover container temporário
//   // -----------------------------
//   document.body.removeChild(tempDiv);

//   // -----------------------------
//   // 14. Retornar Blob do PDF
//   // -----------------------------
//   return pdf.output('blob');
//     }

    const htmlToPdf = async (htmlContent) => {
        // -----------------------------
  // 1. Parâmetros de página A4
  // -----------------------------
  const a4WidthMm = 210;
  const a4HeightMm = 297;
  const marginMm = 10;
  const pxPerMm = 3.78;

  const contentWidthMm = a4WidthMm - 2 * marginMm;   // 190 mm
  const contentHeightMm = a4HeightMm - 2 * marginMm; // 277 mm

  const maxContentWidthPx = contentWidthMm * pxPerMm;

  // -----------------------------
  // 2. Criar container temporário
  // -----------------------------
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;
  Object.assign(tempDiv.style, {
    position: 'absolute',
    left: '-9999px',
    top: '0',
    background: 'white',
    overflow: 'visible',
    width: 'auto'
  });
  document.body.appendChild(tempDiv);
  await new Promise(r => setTimeout(r, 200));

  // -----------------------------
  // 3. Medir largura da tabela
  // -----------------------------
  const tableEl = tempDiv.querySelector('table');
  const tableWidthPx = tableEl
    ? tableEl.offsetWidth
    : contentWidthMm * pxPerMm;

  // -----------------------------
  // 4. Calcular escala
  // -----------------------------
  const scaleFactor =
    tableWidthPx > maxContentWidthPx
      ? maxContentWidthPx / tableWidthPx
      : 1;

  // -----------------------------
  // 5. Aplicar escala
  // -----------------------------
  Object.assign(tempDiv.style, {
    transformOrigin: 'top left',
    transform: `scale(${scaleFactor})`,
    width: `${tableWidthPx}px`
  });
  await new Promise(r => setTimeout(r, 80));

  // -----------------------------
  // 6. Detectar blocos por 2 <tr> vazias
  // -----------------------------
  const trs = Array.from(tempDiv.querySelectorAll('tr'));
  const blockStartsCss = [];

  const isBlank = tr => {
    const tds = Array.from(tr.querySelectorAll('td'));
    return tds.length > 0 && tds.every(td => td.textContent.trim() === '');
  };

  for (let i = 0; i < trs.length - 2; i++) {
    if (isBlank(trs[i]) && isBlank(trs[i + 1])) {
      const next = trs[i + 2];
      blockStartsCss.push(next.offsetTop);
    }
  }
  // garante bloco inicial em 0
  if (blockStartsCss[0] !== 0) blockStartsCss.unshift(0);

  // -----------------------------
  // 7. Gerar canvas
  // -----------------------------
  const canvas = await html2canvas(tempDiv, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#fff',
    logging: false,
    width: tableWidthPx * scaleFactor,
  });
  const cW = canvas.width;
  const cH = canvas.height;

  // -----------------------------
  // 8. Converter offests e limites de bloco
  // -----------------------------
  //  scaleFactor e *2 por html2canvas
  const blockStartsPx = blockStartsCss.map(off => off * scaleFactor * 2);
  const blocks = blockStartsPx.map((start, i) => {
    const end = i < blockStartsPx.length - 1 ? blockStartsPx[i + 1] : cH;
    return { start, height: end - start };
  });

  // -----------------------------
  // 9. Altura de página em px do canvas
  // -----------------------------
  const pageHpx = contentHeightMm * pxPerMm * 2;

  // -----------------------------
  // 10. Montar fatias respeitando blocos
  // -----------------------------
  const slices = [];
  let cursor = 0;

  while (cursor < cH) {
    const rem = cH - cursor;

    // Se cabe todo o resto numa página só, joga tudo
    if (rem <= pageHpx) {
      slices.push({ y: cursor, h: rem });
      break;
    }

    // limite bruto desta página
    let corte = cursor + pageHpx;

    // verifica blocos que começam dentro desta página
    const cand = blocks
      .filter(b => b.start > cursor && b.start < corte)
      .map(b => {
        const spaceAfterStart = pageHpx - (b.start - cursor);
        return { ...b, startOffset: b.start, fit: b.height <= spaceAfterStart };
      });

    // pega primeiro bloco que NÃO cabe (fit === false)
    const naoCabe = cand.find(b => !b.fit);
    if (naoCabe) {
      corte = naoCabe.startOffset;
    }
    // senão, se todos os blocos cabem, mantemos corte = cursor+pageHpx

    const altura = corte - cursor;
    slices.push({ y: cursor, h: altura });
    cursor += altura;
  }

  // -----------------------------
  // 11. Renderizar PDF
  // -----------------------------
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const px2mm = px => (px / 2) / pxPerMm;
  const imgWmm = px2mm(cW);

  for (let i = 0; i < slices.length; i++) {
    const { y, h } = slices[i];
    if (i > 0) pdf.addPage();

    const pc = document.createElement('canvas');
    pc.width = cW;
    pc.height = h;
    pc.getContext('2d').drawImage(canvas, 0, y, cW, h, 0, 0, cW, h);

    pdf.addImage(
      pc,
      'PNG',
      marginMm,
      marginMm,
      imgWmm,
      px2mm(h)
    );
  }

  document.body.removeChild(tempDiv);
  return pdf.output('blob');
    }


    const downloadPdf = (pdfBlob, filename) => {
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };


    const closeWaiver = async (event) => {
        event.preventDefault();

        Swal.fire({
            title: 'Please specify the reason',
            input: 'textarea',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Comment',
            confirmButtonColor: '#112A61',
            showLoaderOnConfirm: true,
            allowOutsideClick: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                //setLoading(true);

                const objToRequest = {
                    "moduleID": moduleID,
                    "selectedCompanyID": selectedCompanyID,
                    "commentApprover": result.value,
                    "reportYearID": selectedReportYearID,
                    "versionIdentifier": versionIdentifier != null ? versionIdentifier : null
                }

                await Api.post(`FormValue/closeWaiver`, objToRequest).then((result) => {
                    success_message("The waiver was closed!");
                    loadData();
                    if (setShowFixedHeader != null)
                        setShowFixedHeader(false);
                }).catch((error) => {
                    exceptionNotificationAPI(error);
                    setLoading(false);
                    if (setLoadingSection != null) {
                        setLoadingSection(false);
                    }
                    if (setShowFixedHeader != null)
                        setShowFixedHeader(false);
                });
            }
        })
    }

    return (
        <Container className="row">
            <div className="col-md-12" style={{ textAlign: 'left' }}>
                {userRoles.includes("RoleInfoHolder") && showButtons && isEditable ? //Info Holder
                    <>
                        {status != 3 && status != 5 && <button className="save-btn" type="submit">SAVE DRAFT</button>}
                        {/* {<button className="save-btn" type="submit">SAVE DRAFT</button>} */}
                        {showSendButton && <button className="send-btn" onClick={(e) => handleSend(e)} type="button">SEND</button>}
                        {moduleObject.data.isHandleAddZeros == true ? <button className="save-btn float-right" onClick={(e) => handleAddZeroes(e, moduleObject, setModuleObject)} type="button">ADD ZEROS</button> : ""}
                    </>
                    : <></>
                }
                {userRoles.includes("RoleInfoHolder") && !showButtons && !isEditable && (moduleObject.isActionPlan || moduleObject?.version?.module?.moduleExternalID == 9000 || moduleObject?.version?.module?.moduleExternalID == 8000) ? //Info Holder allow to send action plans
                    <>
                        {status != 1 && status != 8 && <button className="send-btn" onClick={(e) => handleSaveActionPlans(e)} type="button">SAVE ACTION PLANS</button>}
                    </>
                    : <></>
                }
                {userRoles.includes("RoleApprover") && showButtons && !isEditable && !blockLocalApproverRejection() && //Approver
                    <>
                        <button className="approve-btn" type="button" onClick={(e) => handleApprove(e)}>APPROVE ALL</button>
                        <button className="reject-btn" type="button" onClick={(e) => handleReject(e)}>REJECT ALL</button>
                        <button className="reject-partial-btn" type="button" onClick={(e) => handlePartialReject(e)}>PARTIAL APPROVAL/REJECTION</button>
                    </>
                }
                {userRoles.includes("RoleApprover") && showButtons && !isEditable && blockLocalApproverRejection() && //Approver
                    <>
                        <button className="approve-btn" type="button" onClick={(e) => handleApprove(e)}>APPROVE ALL</button>
                        <button className="reject-partial-btn" type="button" onClick={(e) => handlePartialReject(e)}>PARTIAL APPROVAL/REJECTION</button>
                    </>
                }
                {userRoles.includes("RoleAdmin") && showButtons && !isEditable && //Admin
                    <>
                        <button className="approve-btn" type="button" onClick={(e) => handleReactive(e)}>REACTIVATE</button>
                        <button className="reject-partial-btn" type="button" onClick={(e) => handlePartialReject(e)}>PARTIAL REACTIVATION</button>
                    </>
                }
                {(userRoles.includes("RoleESGManager") || userRoles.includes("RoleESGApprover") || userRoles.includes("RoleESGPerformanceManager")) && showButtons && !isEditable && //manager
                    <>
                        <button className="approve-btn" type="button" onClick={(e) => handleApprove(e)}>APPROVE ALL</button>
                        <button className="reject-btn" type="button" onClick={(e) => handleReject(e)}>REJECT ALL</button>
                        <button className="reject-partial-btn" type="button" onClick={(e) => handlePartialReject(e)}>PARTIAL APPROVAL/REJECTION</button>
                    </>
                }
                {(userRoles.includes("RoleESGManager") || userRoles.includes("RoleESGApprover") || userRoles.includes("RoleESGPerformanceManager") || userRoles.includes("RoleApprover") || userRoles.includes("RoleAdmin")) && showCloseButton &&
                    <>
                        <button className="reject-btn" type="button" onClick={(e) => closeWaiver(e)}>CLOSE</button>
                    </>
                }
                {userRoles.includes("RoleInfoHolder") && moduleObject.version != null && moduleObject?.version?.module?.moduleExternalID == 7000 && //versionIdentifier != null && //Infoholder export Waiver
                    <>
                        <button className="export-btn" type="button" onClick={() => sendExport()}>EXPORT</button>

                    </>
                }
                {(userRoles.includes("RoleInfoHolder") || userRoles.includes("RoleAdmin") || userRoles.includes("RoleApprover")) && moduleObject.version != null && moduleObject?.version?.module?.moduleExternalID == 20000 && //versionIdentifier != null && //Infoholder export Waiver
                    <>
                        <button className="export-btn" type="button" onClick={() => sendExportFumigation()}>EXPORT</button>

                    </>
                }

            </div>

            <div
                id="excel-hidden-container"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    visibility: 'hidden',  // deixa a div “renderizada”, mas invisível
                    width: '1200px',       // ajuste conforme a largura real da sua planilha
                    background: '#fff',    // fundo branco, pois o html2canvas precisa desenhar contra algo
                }}
            ></div>

            <ModalRejectPartial
                showModalRejectPartial={showModalRejectPartial}
                setShowModalRejectPartial={setShowModalRejectPartial}
                ssksToReject={ssksToReject}
                moduleID={moduleID}
                selectedCompanyID={selectedCompanyID}
                selectedReportYearID={selectedReportYearID}
                versionIdentifier={versionIdentifier}
                loadData={loadData}
                setLoading={setLoading}
                setShowFixedHeader={setShowFixedHeader}
                setLoadingSection={setLoadingSection}
                userRoles={userRoles}
            />
        </Container>
    );
}

export default ModuleButtons;
